module.exports = __webpack_public_path__ + "img/icon-car.c416044a.svg";